export default "__VITE_ASSET__21xPYWpn__"